<template>
  <div>
    <b-card bg-variant="light">
      <interest-dropdown @selectedItems="setInterestId" :filtering="interest_filtering" heading="Product Model Interest"></interest-dropdown>
      <product-model-index v-if="interest_id" :filtering="product_model_filtering"></product-model-index>
    </b-card>
  </div>
</template>

<script>
import InterestDropdown from './InterestDropdown.vue'
import ProductModelIndex from './ProductModelIndex.vue'

export default {
  components: {
    ProductModelIndex,
    InterestDropdown
  },
  data() {
    return {
      interest_id: undefined,
      interest_filtering: {
        ids: this.$store.getters['cached_products/interest_ids']
      },
      product_model_filtering: {
        interest_subtree_ids: undefined
      }
    }
  },
  methods: {
    setInterestId(items) {
      this.interest_id = items[0].id
      this.product_model_filtering.interest_subtree_ids = this.interest_id
    }
  }
}
</script>

<style>

</style>